module.exports = __webpack_public_path__ + "img/produit-favoris-full.3e757f88.svg";